import { Forum as ForumIcon } from "@mui/icons-material";
import { Badge, IconButton, Tooltip } from "@mui/material";
import { useEffect, useState } from "react";
import { ISinisterNegotiationInteraction, SinisterNegotiationService } from "../../../shared/services/api/sinister/SinisterNegotiationService";
import { ModalInteractionsHistory } from "./Modals/ModalInteractionsHistory";

interface Props {
	sinisterId: string;
	refreshToken?: number;
}

export const CreditRecoveryActionsIndicator = ({ sinisterId, refreshToken }: Props) => {
	const [interactions, setInteractions] = useState<ISinisterNegotiationInteraction[]>([]);
	const [openModal, setOpenModal] = useState(false);

	useEffect(() => {
		SinisterNegotiationService.getInteractions(sinisterId).then((result) => {
			if (!(result instanceof Error)) setInteractions(result);
		});
	}, [sinisterId, refreshToken]);

	const hasInteractions = interactions.length > 0;

	return (
		<>
			<Tooltip title={hasInteractions ? "Ver histórico de ações" : "Nenhuma ação registrada"}>
				<IconButton size="small" onClick={() => setOpenModal(true)}>
					<Badge badgeContent={interactions.length} color="primary" showZero={!hasInteractions}>
						<ForumIcon fontSize="small" color={hasInteractions ? "primary" : "disabled"} />
					</Badge>
				</IconButton>
			</Tooltip>

			<ModalInteractionsHistory open={openModal} sinisterId={sinisterId} onClose={() => setOpenModal(false)} />
		</>
	);
};
